import { ConfigConcessionaria } from '@/models/ConcessionariaModel';
import { getConcessionariaConfig } from '@/services/GeralService';
import { defineStore } from 'pinia';

export const useConfigConcessionariaStore = defineStore('useConfigConcessionariaStore', {
    state: () => ({
        config: null as ConfigConcessionaria | null,
        configConcessionariaSelected: null as ConfigConcessionaria | null,
        codConcessionariaSelected: 0 as number,
    }),
    actions: {
        async setConfigConcessionaria(codConcessionaria: number) {
            try {
                const config = await getConcessionariaConfig(codConcessionaria)
                this.config = config;
            } catch (error) {
                console.error('Error fetching concessionaria config:', error);
            }
        },
        async getConfigConcessionaria(codConcessionaria: number | string) {
            try {
                const config = await getConcessionariaConfig(codConcessionaria)
                this.configConcessionariaSelected = config;
            } catch (error) {
                console.error('Error fetching concessionaria config:', error);
            }
        },
        setCodConcessionariaSelected(codConcessionaria: number) {
            this.codConcessionariaSelected = codConcessionaria;
        }
    },
    getters: {
        getConfig: (state) => state.config,
        getConfigConcessionariaSelected: (state) => state.configConcessionariaSelected,
        getCodConcessionariaSelected: (state) => state.codConcessionariaSelected,
    },
});

